import 'client-only';

import { logger } from '@curology/logger/client';
import { parseQueryString } from '@curology/site-tools';

import COOKIE_KEYS from '@/consts/cookieKeys';
import cookies from '@/utils/cookies/client';

export const captureInviteToken = (): void => {
  try {
    if (typeof window === 'undefined' || cookies.has(COOKIE_KEYS.inviteToken)) {
      return;
    }

    const { location } = window;
    const queryParams = parseQueryString(location);
    const inviteToken = queryParams.t;

    if (inviteToken) {
      cookies.set(COOKIE_KEYS.inviteToken, inviteToken);
    }
  } catch (error) {
    logger.error(`Error capturing invite token: ${error}`);
  }
};
